export class TeamPopup  {
	init() {
		let items = document.querySelectorAll('.articles-list--team-list .articles-list__item'),
			popup = document.getElementById('teamPopup');

		items.forEach(function(el) {
			el.addEventListener('click', function() {
				popup.querySelector('#personImage').src = el.dataset.image;
				popup.querySelector('#personName').innerText = el.querySelector('.name').innerText;
				popup.querySelector('#personPosition').innerText = el.dataset.position;
				popup.querySelector('#personDescription').innerText = el.dataset.description;
				popup.querySelector('#personLinkedin').href = el.dataset.linkedin;
				popup.querySelector('#personMail').href = "mailto:" + el.dataset.email;
			})
		})
	}
}